import React from 'react'

// material ui
import Box from '@mui/material/Box'

// atomic components/containers
import Typography from '@mui/material/Typography'

// components specific to registration
import WarningMessage from 'components/shared/ErrorMessage/UI'

const NotCompleteWarning = props => {
  return (
    <WarningMessage
      variant='warning'
      message='Your registration is not yet complete.'
    >
      <Box my={2}>
        <Typography gutterBottom variant='body1'>
          Please carefully review your information. Click the edit buttons to
          make changes if any details are incorrect.
        </Typography>
        <Typography variant='body1'>
          Once you have accepted the legal agreement below, your payment will be
          submitted.
        </Typography>
      </Box>
    </WarningMessage>
  )
}

export default NotCompleteWarning
